'use client'

import { useState } from 'react'
import { ChapterWithHsCodesDto, HsCodeDto } from '@/modules/hs/types/hs-response'
import HsTreeNode from './HsTreeNode'
import { ChevronDown, ChevronUp } from 'lucide-react'

interface ChapterGroupProps {
  chapter: ChapterWithHsCodesDto
  isExpanded?: boolean
  onToggleExpand?: () => void
  highlightTerm?: string
}

// Recursive function to count only detail nodes in the tree
function countDetailNodes(nodes: HsCodeDto[]): number {
  let count = 0
  for (const node of nodes) {
    if (node.isDetail ?? !node.children) {
      count++
    }
    if (node.children && node.children.length > 0) {
      count += countDetailNodes(node.children)
    }
  }
  return count
}

export default function ChapterGroup({
  chapter,
  isExpanded = true,
  onToggleExpand,
  highlightTerm,
}: ChapterGroupProps) {
  // Extract chapter number from numberVN (e.g., "Chương 09" -> "09")
  const chapterNumber = chapter.numberVN?.replace('Chương ', '') || '??'

  return (
    <div className="chapter-group cl-card-border scroll-mt-24">
      {/* Chapter Header */}
      <div
        className="chapter-header-new"
        onClick={onToggleExpand}
        style={{ cursor: 'pointer' }}
      >
        <div className="chapter-icon-new">{chapterNumber}</div>
        <div className="chapter-title-new">
          <h2>{chapter.numberVN}</h2>
          <p>{chapter.nameVN}</p>
        </div>
        <div className="chapter-count-new">
          {countDetailNodes(chapter.hsCodes || [])} mã
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
          {isExpanded ? (
            <ChevronUp size={20} />
          ) : (
            <ChevronDown size={20} />
          )}
        </div>
      </div>

      {/* Tree Container */}
      {isExpanded && (
        <div className="tree-container">
          {chapter.hsCodes?.map((code: HsCodeDto, index: number) => (
            <HsTreeNode key={`${code.hsCode}-${index}`} code={code} level={0} highlightTerm={highlightTerm} />
          ))}
        </div>
      )}
    </div>
  )
}
